const ANSWER_DURATION = 280;

export default {
  name: "brand-article",
  props: {
    // description_blocks зі списку /catalog/categories (бренд або колекція).
    // Порядок секцій і порядок items уже правильні — на фронті не сортуємо.
    blocks: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      ANSWER_DURATION,
      // Розгорнуті рядки акордеона, ключ — items[].id (унікальний глобально).
      openItems: {},
      activeTabId: null,
    };
  },
  computed: {
    sections() {
      return (this.blocks || []).filter(Boolean);
    },
    // Прапорця is_hero немає — правило суто позиційне: індекс 0 = шапка опису.
    heroSection() {
      return this.sections[0] || null;
    },
    // Чіпси будуються з самих блоків — окремого масиву бекенд не віддає.
    // Потрапляють лише секції, у яких заповнений anchorLabel.
    tabSections() {
      return this.sections.slice(1).filter(block => block.anchorLabel);
    },
    // Секції без anchor_label у навігацію не потрапляють, тож показуємо їх завжди,
    // одразу після шапки — інакше вони були б недосяжні.
    staticSections() {
      return this.sections.slice(1).filter(block => !block.anchorLabel);
    },
    activeSection() {
      return this.tabSections.find(block => block.id === this.activeTabId) || null;
    },
  },
  watch: {
    // Перший чіпс активний за замовчуванням; при зміні бренду/колекції — знову перший.
    tabSections: {
      immediate: true,
      handler(list) {
        const exists = list.some(block => block.id === this.activeTabId);
        if (!exists) this.activeTabId = list.length ? list[0].id : null;
      },
    },
  },
  methods: {
    selectTab(id) {
      this.activeTabId = id;
    },
    sectionId(block) {
      return `desc-block-${block.id}`;
    },
    isHero(block) {
      return block === this.heroSection;
    },
    // Секція-вкладка (має чіпс у навігації) — на відміну від шапки й секцій без чіпса.
    isTab(block) {
      return this.tabSections.includes(block);
    },
    isActiveTab(block) {
      return block === this.activeSection;
    },
    // Рендеряться всі секції (текст лишається в DOM під FAQ-розмітку й індексацію),
    // ховаємо неактивні вкладки через v-show.
    isVisible(block) {
      return !this.isTab(block) || this.isActiveTab(block);
    },
    isOpen(id) {
      return !!this.openItems[id];
    },
    toggleItem(id) {
      this.$set(this.openItems, id, !this.openItems[id]);
    },
    onAnswerEnter(el) {
      el.style.height = "0px";
      el.getBoundingClientRect();
      el.style.height = `${el.scrollHeight}px`;
    },
    onAnswerAfterEnter(el) {
      el.style.height = "auto";
    },
    onAnswerLeave(el) {
      el.style.height = `${el.scrollHeight}px`;
      el.getBoundingClientRect();
      el.style.height = "0px";
    },
    onAnswerAfterLeave(el) {
      el.style.height = "";
    },
  },
};
